
import { BookingItem } from "@/models/www/store/BookingSummary";
import { defineComponent, PropType } from "vue";

export default defineComponent({
	props: {
		extras: {
			type: Array as PropType<BookingItem[]>,
			default: () => {
				return [] as BookingItem[];
			},
		},
		currency: String,
		displayTime: Boolean,
	},
	setup() {
		return {};
	},
});
